import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import Spinner from 'react-bootstrap/Spinner';

const BaseModal = (props) =>
{
	const {
		okButtonTag, cancelButtonTag, onOk, onCancel, trigger, toggle, onOpened, size, hideCancel, hideOk,buttonLoader,disable, cancelButtonClass, okButtonClass
	} = props;
	return (<Modal isOpen={trigger} toggle={toggle} backdrop="static" size={size ?? "md"} onOpened={onOpened} onClosed={onCancel}>
		<ModalHeader className='custom_header_colourTwo' toggle={toggle}>{props.title}</ModalHeader>
		<ModalBody>
			{props.children}
		</ModalBody>
		<ModalFooter>
			{!hideCancel ? (<Button className={cancelButtonClass || "btn btn-primaryTwo"} onClick={onCancel}>{cancelButtonTag ?? "Cancel"}</Button>) : ""}{' '}
			{!hideOk ? <Button className={okButtonClass || "btn btn-primaryTwo"} disabled={buttonLoader} onClick={onOk}>{okButtonTag ?? "Ok"}
				{buttonLoader && <Spinner
					as="span"
					animation="border"
					size="sm"
					role="status"
					aria-hidden="true"
					style={{
						margin: "0px 8px"
					}}
				/>}</Button> : ""}
		</ModalFooter>
	</Modal>);
}

export default BaseModal;